import { render, staticRenderFns } from "./ListFolders.vue?vue&type=template&id=0b1348f7&"
import script from "./ListFolders.vue?vue&type=script&lang=js&"
export * from "./ListFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1348f7')) {
      api.createRecord('0b1348f7', component.options)
    } else {
      api.reload('0b1348f7', component.options)
    }
    module.hot.accept("./ListFolders.vue?vue&type=template&id=0b1348f7&", function () {
      api.rerender('0b1348f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileStorage/ListFolders.vue"
export default component.exports